import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { injectIntl, FormattedMessage } from 'react-intl';
import { CustomSelectField } from '../../components';
import enums from '../../constants/defaultEnums';
import formUtils from '../../utils/formUtils';
import ServiceDetailsSection from './MilitaryForm/ServiceDetailsSection';
import DeploymentSection from './MilitaryForm/DeploymentSection';
import DischargeSection from './MilitaryForm/DischargeSection';
import DisabilitySection from './MilitaryForm/DisabilitySection';
import ProofSection from './MilitaryForm/ProofSection';

function MilitaryForm({ form, assistanceReqConfigs, intl }) {
  const militaryAffiliation = form.getFieldState('military.affiliation');
  const isMilitaryMemberOrVeteran = _.get(militaryAffiliation, 'value') === 'military_member_or_veteran';
  const hasBeenDeployed = _.get(form.getFieldState('military.deployed'), 'value') === 'yes';
  const hasVAServiceDisability = _.get(form.getFieldState('military.service_connected_disability'), 'value') === 'yes';
  const hasVeteranStatusProof = _.get(form.getFieldState('military.proof_of_veteran_status'), 'value') === 'yes';
  const militaryEnums = enums.contact_data.military;

  const yesterdayDate = new Date();
  yesterdayDate.setDate(yesterdayDate.getDate() - 1);
  const collected_attributes = _.get(assistanceReqConfigs, 'data.data[0].attributes.collected_attributes');

  return (
    collected_attributes ? (
      <div>
        {collected_attributes.military_affiliation && (
          <CustomSelectField
            name="military.affiliation"
            id="uu_contact_affiliation"
            label={<FormattedMessage id="R6nCuZ" description="militaryAffiliation" defaultMessage="Military Affiliation" />}
            options={formUtils.translateOptions(intl, militaryEnums.affiliation)}
            required
          />
        )}
        {isMilitaryMemberOrVeteran && (
          <>
            <h3 className='mb-2 military ui-h3-heavy'>
              <FormattedMessage id="sw0X4x" description="militaryInformation" defaultMessage="Military Information" />
            </h3>
            <ServiceDetailsSection
              militaryEnums={militaryEnums}
              collected_attributes={collected_attributes}
              intl={intl}
              yesterdayDate={yesterdayDate}
            />
            <DeploymentSection
              militaryEnums={militaryEnums}
              collected_attributes={collected_attributes}
              intl={intl}
              yesterdayDate={yesterdayDate}
              hasBeenDeployed={hasBeenDeployed}
            />
            <DischargeSection
              militaryEnums={militaryEnums}
              collected_attributes={collected_attributes}
              intl={intl}
            />
            <DisabilitySection
              militaryEnums={militaryEnums}
              collected_attributes={collected_attributes}
              intl={intl}
              hasVAServiceDisability={hasVAServiceDisability}
            />
            <ProofSection
              militaryEnums={militaryEnums}
              collected_attributes={collected_attributes}
              intl={intl}
              hasVeteranStatusProof={hasVeteranStatusProof}
            />
          </>
        )}
      </div>
    ) : ''
  );
}

MilitaryForm.propTypes = {
  assistanceReqConfigs: PropTypes.object.isRequired,
  form: PropTypes.shape({ getFieldState: PropTypes.func.isRequired }).isRequired,
};

export default injectIntl(MilitaryForm);
